"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Text_1 = require("../Text/Text");
const Stepper_styles_1 = require("./Stepper.styles");
const Stepper = ({ currentStep, totalSteps, hideText = false, }) => {
    const stepsValid = checkStepsValid(currentStep, totalSteps);
    if (!stepsValid) {
        console.error("Stepper error: steps are not valid. currentStep must be >= 1 and <= totalSteps and totalStep must be > 1");
        return null;
    }
    const stepsArray = generateStepsArray(totalSteps);
    return (react_1.default.createElement(Stepper_styles_1.StyledStepper, null,
        !hideText && (react_1.default.createElement(Text_1.Text, { variant: "note", colour: "metal", skinny: true },
            "STEP ",
            currentStep,
            " OF ",
            totalSteps)),
        react_1.default.createElement("div", { className: "steps" }, stepsArray.map((step) => (react_1.default.createElement(Stepper_styles_1.StyledStep, { key: step, active: step <= currentStep }))))));
};
function checkStepsValid(currentStep, totalSteps) {
    const isCurrentStepValid = !!currentStep && currentStep >= 1;
    const isTotalStepsValid = totalSteps > 1;
    const isCurrentStepInValidRange = !!currentStep && currentStep <= totalSteps;
    return isCurrentStepValid && isCurrentStepInValidRange && isTotalStepsValid;
}
function generateStepsArray(steps) {
    if (!steps)
        return [];
    return [...Array(steps + 1).keys()].slice(1);
}
exports.default = Stepper;
//# sourceMappingURL=Stepper.js.map